var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { useFault } from "../useFault";
import { FaultCategory } from "../../../../../graphql";
import { DynamicForm } from "../../../../../components";
import { WireMockWarning } from "../WireMockWarning";
import { useAnalytics } from "../../../../../analytics";
export var FaultEditor = function (_a) {
    var value = _a.value, onSave = _a.onSave, onCancel = _a.onCancel, containersForService = _a.containersForService, microsGroupsForService = _a.microsGroupsForService, serviceId = _a.serviceId, environment = _a.environment, faultBeingEditedIndex = _a.faultBeingEditedIndex;
    var _b = useFault(value, containersForService, microsGroupsForService, serviceId, environment, faultBeingEditedIndex), fault = _b.fault, fields = _b.fields;
    var _c = __read(useState(false), 2), isWireMockWarningVisible = _c[0], setIsWireMockWarningVisible = _c[1];
    var showWireMockWarning = function () {
        setIsWireMockWarningVisible(true);
    };
    var hideWireMockWarning = function () {
        setIsWireMockWarningVisible(false);
    };
    var saveFault = function () {
        onSave(fault);
    };
    var sendUIEvent = useAnalytics().sendUIEvent;
    var onSubmit = function () {
        sendUIEvent({
            source: "createWargamePlanTaskGroupDefinitionStep",
            actionSubject: "button",
            action: "clicked",
            actionSubjectId: "addFault",
            attributes: {
                fault: fault
            }
        });
        if (fault.faultCategory === FaultCategory.application_layer) {
            showWireMockWarning();
            return;
        }
        saveFault();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DynamicForm, { fields: fields, submitButtonText: "Add Fault", onSubmit: onSubmit, onCancel: onCancel }),
        React.createElement(WireMockWarning, { isVisible: isWireMockWarningVisible, onClose: hideWireMockWarning, onConfirm: saveFault, fault: fault, serviceId: serviceId })));
};
